import { render, staticRenderFns } from "./resultDialog.vue?vue&type=template&id=1ac0fa9a&scoped=true&lang=pug&"
import script from "./resultDialog.vue?vue&type=script&lang=js&"
export * from "./resultDialog.vue?vue&type=script&lang=js&"
import style0 from "./resultDialog.vue?vue&type=style&index=0&id=1ac0fa9a&prod&lang=less&scoped=true&"
import style1 from "./resultDialog.vue?vue&type=style&index=1&id=1ac0fa9a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0fa9a",
  null
  
)

export default component.exports